import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Dilucion/imprimirDilucion`, method: 'POST', body: list, token: token})
}